export const registerMessages = {
    sendEmailCode: "Registro exitoso. Espera por la confirmacion de usuario por parte del administrador",
    errorCodeMaxAttempts: "¡Supero el limite de intentos!",
    usernameExistsException: "¡El usuario ya se encuentra registrado!",
  };
  